import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AnalyticsModule } from '@flyfreely-portal-ui/analytics';
import { EditableModule } from '@flyfreely-portal-ui/editable';
import { EnhancedHelpModule } from '@flyfreely-portal-ui/enhanced-help';
import { ValidationModule } from '@flyfreely-portal-ui/validation';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoadingIndicatorModule } from 'libs/loading-indicator/src/lib/loading-indicator.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MissionObjectivesList } from './mission-objectives-list.component';

@NgModule({
    imports: [
        CommonModule,
        LoadingIndicatorModule,
        FormsModule,
        ReactiveFormsModule,
        ValidationModule,
        NgSelectModule,
        EnhancedHelpModule,
        AnalyticsModule,
        EditableModule,
        TooltipModule,
        MatSlideToggleModule
    ],
    providers: [],
    bootstrap: [],
    declarations: [MissionObjectivesList],
    exports: [MissionObjectivesList]
})
export class MissionObjectivesModule {}
